import { Text, VStack } from '@chakra-ui/react'

const QAItem = ({ question, answer }: { question: string; answer: string }) => {
  return (
    <VStack
      w={{
        base: '100%',
        md: 550,
        lg: 800
      }}
      alignItems="flex-start"
      gap={1}
      mt={3}
    >
      <Text textStyle="gripContentSmall" fontWeight={700}>
        {question}
      </Text>

      <Text textStyle="gripReviewItemDesc">{answer}</Text>
    </VStack>
  )
}

const QA = () => {
  return (
    <VStack>
      <Text
        w={{
          base: '100%',
          md: 550,
          lg: 800
        }}
        textStyle="gripMainTitle"
      >
        FREQUENTLY ASKED QUESTIONS
      </Text>
      <QAItem
        question="What makes the Arctic Grip Tumbler stand out from other tumblers on the market?"
        answer="The Arctic Grip Tumbler stands out thanks to its premium materials, superior insulation, non-slip suction grip base, and a leak-proof lid. These features ensure that your drinks stay at the desired temperature, remain secure, and are virtually spill-free."
      />
      <QAItem
        question="How long does the Arctic Grip Tumbler keep beverages cold or hot?"
        answer="Our tumbler can keep beverages cold for up to 24 hours and hot for up to 12 hours, thanks to its advanced double-wall vacuum insulation."
      />
      <QAItem
        question="Is the Arctic Grip Tumbler suitable for both hot and cold drinks?"
        answer="Yes, absolutely! Whether you're sipping on your favourite hot coffee or enjoying an ice-cold beverage, the Arctic Grip Tumbler is designed to maintain the ideal temperature for your drinks."
      />
      <QAItem
        question="Does the tumbler leave any metallic taste in the beverages?"
        answer="No, it doesn't. The Arctic Grip Tumbler is constructed with high-quality stainless steel, which ensures that your drinks taste exactly as they should, without any metallic aftertaste."
      />
      <QAItem
        question="Is the tumbler compatible with car cup holders?"
        answer="Yes, it is. The Arctic Grip Tumbler is designed to fit into most standard car cup holders, making it a convenient choice for your on-the-go lifestyle."
      />
      <QAItem
        question="Is the tumbler dishwasher safe?"
        answer="No, the Arctic Grip Tumbler is not dishwasher safe. We recommend hand washing the tumbler to preserve its quality and longevity. The lid, however, is top-rack dishwasher safe for your convenience."
      />
      <QAItem
        question="Can I use the Arctic Grip Tumbler for carbonated beverages?"
        answer="Yes, you can use the tumbler for carbonated beverages, but please be cautious when opening the lid, as the pressure from carbonation can cause some fizz upon opening."
      />
      <QAItem
        question="Can I use the Arctic Grip Tumbler for both indoor and outdoor activities?"
        answer="Absolutely! The Arctic Grip Tumbler is versatile and suitable for all occasions, whether at home, in the office, or on an outdoor adventure. Its non-slip base makes it perfect for various environments."
      />
      <QAItem
        question="Is the Arctic Grip Tumbler environmentally friendly?"
        answer=" Yes, it is. Our tumbler is made with BPA-free materials, promoting your health and environmental consciousness. By using a reusable tumbler, you're helping reduce single-use."
      />
    </VStack>
  )
}
export default QA
